var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.records,
            border: "",
            size: "mini",
            "element-loading-text": "正在加载中～",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "编号", prop: "complaintNo", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-link",
                      {
                        staticClass: "font-12 font-normal",
                        attrs: {
                          type: "success",
                          underline: false,
                          href: "/customer/complaint/detail?id=" + scope.row.id,
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(scope.row.complaintNo))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "类型",
              prop: "typeName",
              align: "center",
              width: "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "来源",
              prop: "resName",
              align: "center",
              width: "120",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "责任部门", prop: "merchantName", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "处理状态",
              prop: "statusName",
              align: "center",
              width: "140",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "反馈时间", prop: "createTime", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "反馈内容", prop: "remark", align: "center" },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "right",
            "margin-right": "20px",
            "margin-top": "20px",
          },
        },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.paginationObj.current,
              "page-size": _vm.paginationObj.size,
              background: "",
              layout: "prev, pager, next",
              total: _vm.total,
              size: "mini",
            },
            on: { "current-change": _vm.handleCurrentChange },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }